import React, { Component } from "react";

export default class Dot extends Component {
	
	constructor(props) {
		super(props);
		this.state = {
			x: 0,
			y: 0
		};
	}

	logMousePosition = e => {
		this.setState({
			x: e.clientX,
			y: e.clientY
		});
	};
	componentDidMount() {
    	window.addEventListener("mousemove", this.logMousePosition);
    }
	render() {
		return (
			<div className="c-dot" style={{ left: this.state.x + 'px', top: this.state.y + 'px' }}>
				<div className="c-dot__left">
					<svg x="0px" y="0px" viewBox="0 0 18 26">
						<path d="M9.38,0.08c-0.24-0.1-0.52-0.1-0.76,0C8.5,0.13,8.38,0.2,8.29,0.29l-8,8c-0.39,0.39-0.39,1.02,0,1.41 s1.02,0.39,1.41,0L8,3.41V25c0,0.55,0.45,1,1,1s1-0.45,1-1V3.41l6.29,6.29c0.39,0.39,1.02,0.39,1.41,0C17.9,9.51,18,9.26,18,9 s-0.1-0.51-0.29-0.71l-8-8C9.62,0.2,9.5,0.13,9.38,0.08z"/>
					</svg>
				</div>
				<div className="c-dot__right">
					<svg x="0px" y="0px" viewBox="0 0 18 26">
						<path d="M9.38,0.08c-0.24-0.1-0.52-0.1-0.76,0C8.5,0.13,8.38,0.2,8.29,0.29l-8,8c-0.39,0.39-0.39,1.02,0,1.41 s1.02,0.39,1.41,0L8,3.41V25c0,0.55,0.45,1,1,1s1-0.45,1-1V3.41l6.29,6.29c0.39,0.39,1.02,0.39,1.41,0C17.9,9.51,18,9.26,18,9 s-0.1-0.51-0.29-0.71l-8-8C9.62,0.2,9.5,0.13,9.38,0.08z"/>
					</svg>
				</div>
			</div>
		);
  	}
}